<div class="station-selector-container" id="station-selector-container">
  <label for="stations-dropdown" class="stations-label" id="stations-label">STATION</label>
  <input
    id="stations-dropdown"
    type="text"
    class="form-control"
    [ngbTypeahead]="search"
    (focus)="focus$.next($event.target.value)"
    (click)="click$.next($event.target.value)"
    (selectItem)="selectedItem($event)"
    [resultTemplate]="rt"
    [inputFormatter]="formatter"
    #instance="ngbTypeahead"
    maxlength="3"
  />

  <ng-template #rt let-r="result" let-t="term">
    <ngb-highlight [result]="r.airportCode" [term]="t"></ngb-highlight>
  </ng-template>
</div>
